module.exports = __webpack_public_path__ + "static/barbarawork2-551879cc325a4b6615fcee849eef0b39.jpg";